import InfiniteScroll from 'react-infinite-scroller';

import PostCard from 'components/post/PostCard';

import { PostType } from 'graphql/types';

import css from './PostsList.module.scss';

interface IProps {
  posts: PostType[];

  onLoadMore(): void;
}

export default function PostsList({ posts, onLoadMore }: IProps) {
  return (
    <div className={css.block}>
      <InfiniteScroll
        loadMore={onLoadMore}
        hasMore={posts.length > 0}
        threshold={100}
      >
        <div className={css.posts}>
          {posts.map((post, index) => (
            <PostCard key={`post_card_${index}`} post={post} index={index} />
          ))}
        </div>
      </InfiniteScroll>
    </div>
  );
}
